<i18n>
{
	"en": {
		"from": "From",
		"to": "To",
		"departure": "Planned departure",
		"arrival": "Planned arrival"
	},
	"no": {
		"from": "Fra",
		"to": "Til",
		"departure": "Planlagt avgang",
		"arrival": "Planlagt ankomst"
	}
}
</i18n>
<template>
	<div class="map-trip-search-info">

		<t-text color="#7b8b9a">{{$t('from')}}</t-text>
		<t-text color="#1a3e67" bold="true">{{getProperty(trip.fromAddress, 'name')}}</t-text>

		<t-text color="#7b8b9a">{{$t('to')}}</t-text>
		<t-text color="#1a3e67" bold="true">{{getProperty(trip.toAddress, 'name')}}</t-text>

		<template v-if="dateExists(trip.atd)">
			<t-text color="#7b8b9a">{{$t('departure')}}</t-text>
			<t-text color="#1a3e67" bold="true">{{getDate(trip.etd)}}</t-text>
		</template>

		<template v-else >
			<t-text color="#7b8b9a">{{$t('arrival')}}</t-text>
			<t-text color="#1a3e67" bold="true">{{getDate(trip.eta)}}</t-text>
		</template>
	</div>
</template>
<script>
import TText from './TText.vue';
import moment from 'moment';
export default {
	name: 'MapTripSearchInfo',
	components: { TText },
	props: {
		trip: {
			type: Object,
			required: true
		}
	},
	methods: {
		dateExists(dateObj) {
			return dateObj && dateObj.date;
		},
		getDate(dateObj) {
			if (dateObj && dateObj.epoch)
				return moment(dateObj.epoch).format('DD.MM.YYYY HH:mm');
			return '';
		},
		getProperty(object, propKey) {
			if (!object) return '';
			return object[propKey];
		},
	}
};
</script>

<style scoped>
.map-trip-search-info > * {
	margin-left: 10px;
}

</style>
